import React from 'react'
import ProductsList from './products/products_list'
import Page from 'ui/page'
import styled from 'styled-components'
import cn from 'classnames'
import parse from 'html-react-parser'
import {Row, Col, Card, CardHeader, CardBody, Button} from 'reactstrap'
import Guides from './products/guides'
import GoogleReviews from "ui/google_reviews"

const DestinationFeatured = styled.div`
  position: relative;
  width: 100%;
  height: 350px;

  .destination-header-caption {
    position: absolute;
    inset: 0; /* sustituye top/left/right/bottom: 0 */
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    h1 {
      color: white;
      font-size: 4.2em;
      font-weight: bold;
      text-shadow: 0 0 20px #000;
      margin: 0;
    }

    .subtitle {
      color: white;
      font-size: 2em;
      font-weight: bold;
      text-shadow: 0 0 20px #000;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Products = (props) => {
  const { destination, user, mode, urls, tour_guides } = props
  const { headline, banner_url, info, intro, params } = destination || {}
  const saleChannelTarget = user?.user_data?.user?.sale_channel_target

  const showMeetingGuides = params?.show_meeting_guides || true

  return (
    <Page {...props} className="mt-0">
      {saleChannelTarget === 'b2c' && headline && banner_url && (
        <DestinationFeatured>
          <div className="destination-header-caption">
            <div>
              <h1>{headline}</h1>
              {false && <div className="subtitle">Subtitle</div>}
            </div>
          </div>
          <img src={banner_url} alt={headline || 'destination banner'} />
        </DestinationFeatured>
      )}

      <div
        className={cn(
          'page',
          mode === 'web'
            ? 'container mt-3 pt-3 mt-lg-4 pt-lg-4'
            : 'container mt-3 mb-3'
        )}
      >
        {saleChannelTarget !== 'b2b' && intro &&
          <Row className='my-5' style={{fontSize: '1.15em'}}>
            <Col>
              {parse(intro)}
            </Col>
          </Row>
        }

        <ProductsList {...props} />

        {saleChannelTarget !== 'b2b' && tour_guides?.length > 0 && showMeetingGuides &&
          <Row className='my-5' style={{fontSize: '1.15em'}}>
            <Col>
              <Guides tour_guides={tour_guides}/>
            </Col>
          </Row>
        }

        {saleChannelTarget !== 'b2b' && info &&
          <Row className='my-5' style={{fontSize: '1.15em'}}>
            <Col>
              {parse(info)}
            </Col>
          </Row>
        }

        {params && params.barcelona_must_to_know &&
          <Card className='border-primary rounded-5 text-center my-5 py-3'>
            <CardBody>
              <div className='h1 text-primary fw-bold'>Barcelona</div>
              <div className="fw-bold" style={{fontSize: '1.25em'}}>Everything You Need To Know</div>
              <Button color="primary" className="btn btn-primary rounded-pill px-5 py-3 mt-3 fw-bold" href={params.barcelona_must_to_know}>
                Learn More
              </Button>
            </CardBody>
          </Card> 
        }        

        {params && params.place_id &&
          <GoogleReviews destination={destination} url={urls.reviews}/>
        }
      
        <div className="pb-5"/>
      </div>
    </Page>
  )
}

export default Products
